import React from 'react';
import { Brain, Shield, Heart } from 'lucide-react';
export function MechanismSection() {
  const pillars = [{
    icon: <Brain className="w-8 h-8 text-[#D4A853]" data-id="element-101" />,
    title: 'Regulación primero',
    desc: 'Primero calmar el cuerpo, luego hablar.'
  }, {
    icon: <Shield className="w-8 h-8 text-[#D4A853]" data-id="element-102" />,
    title: 'Seguridad inmediata',
    desc: 'Crear un ancla de calma que el niño pueda sentir.'
  }, {
    icon: <Heart className="w-8 h-8 text-[#D4A853]" data-id="element-103" />,
    title: 'Conexión antes de corrección',
    desc: 'Fortalecer el vínculo en el momento difícil.'
  }];
  return <section className="bg-[#4A6741] py-14 md:py-24 px-5 text-white relative overflow-hidden" data-id="element-104">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-105">
        <div className="text-center mb-10" data-id="element-106">
          <span className="inline-block bg-[#D4A853]/20 text-[#D4A853] px-4 py-1 rounded-full text-xs font-bold tracking-wider uppercase mb-4" data-id="element-107">
            El Método
          </span>
          <h2 className="text-2xl md:text-4xl font-bold mb-5" data-id="element-108">
            El método detrás del Protocolo SOS
          </h2>
          <p className="text-base md:text-xl text-[#F0F4EC] leading-relaxed font-light max-w-2xl mx-auto" data-id="element-109">
            Este enfoque no se centra primero en controlar conducta. Se centra
            en ayudar al cuerpo del niño a salir del estado de alerta para que
            puedas intervenir con más calma y efectividad.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8" data-id="element-110">
          {pillars.map((pillar, idx) => <div key={idx} className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 text-center flex flex-col items-center" data-id="element-111">
              <div className="w-14 h-14 bg-[#D4A853]/20 rounded-full flex items-center justify-center mb-4" data-id="element-112">
                {pillar.icon}
              </div>
              <h3 className="font-bold text-lg mb-2" data-id="element-113">{pillar.title}</h3>
              <p className="text-[#F0F4EC]/90 text-sm leading-relaxed" data-id="element-114">
                {pillar.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}